import React from "react";
import { graphql } from "gatsby";
import PageLayout from "../components/PageLayout";
import { ProductComponent } from "../components/FlexibleComponents/ProductComponent";
import { Filters } from "../components/Filters/Filters";

export default function productCategoryComponents({ data: { page } }) {
  const breadcrumbs = [
    {
      text: "Home",
      url: "/",
    },
    ...(
      page.ancestors?.nodes.length > 0 && page.ancestors?.nodes[0].ancestors?.nodes.length > 0
        ? [{
          text: page.ancestors.nodes[0].ancestors.nodes[0].name,
          url: page.ancestors.nodes[0].ancestors.nodes[0].uri
        }]
        : []
    ),
    ...(
      page.ancestors?.nodes.length > 0
        ? [{
          text: page.ancestors.nodes[0].name,
          url: page.ancestors.nodes[0].uri
        }]
        : []
    ),
    {
      text: page.name,
      url: page.uri,
    },
  ]

  return (
    <PageLayout
      seo={page}
      breadcrumbs={breadcrumbs}
      disableSubscribeToNewsletter={page.pageSettings?.disableGlobalSubscribeToNewsletterComponent}
      useSsss={page.pageSettings?.useSsss}
    >
      {page.productCategoryData.components
        ? page.productCategoryData.components.map((component, index) => (
            component && <ProductComponent component={component} page={page} source={page.uri} key={`${component}${index}`} />
          ))
        : `No content`}
    </PageLayout>
  )
}

export const query = graphql`query ($id: String!) {
  page: wpProductCategory(id: {eq: $id}) {
    pageSettings {
      disableGlobalSubscribeToNewsletterComponent
      useSsss
    }
    name
    uri
    ancestors {
      nodes {
        name
        uri
        ancestors {
          nodes {
            name
            uri
          }
        }
      }
    }
    productCategoryData {
      showApplicationsFilter
      showDepthFilter
      showFilledWeightFilter
      showHeightFilter
      showHeightWithFenceFilter
      showWeightFilter
      showWidthFilter
      showCrashTestedFilter
      showWindTunnelTestedFilter
      showChapter8Filter
      crashTestedTooltip
      windTunnelTestedTooltip
      chapter8Tooltip
      filterTitle
      filterSubtitle
      components {
        ... on WpProductCategory_Productcategorydata_Components_CustomTiles {
          fieldGroupName
          background
          overhang
          overhangMobile
          titleGroup {
            element
            text
          }
          content
          button {
            target
            title
            url
          }
          products {
            ... on WpProduct {
              title
              uri
              id
              menuOrder
              wpChildren {
                nodes {
                  ... on WpProduct {
                    productData {
                      productMeta {
                        stackStatus
                        hirePrice {
                          price
                          info
                          priceOnApplication
                        }
                        buyPrice {
                          price
                          info
                          priceOnApplication
                        }
                      }
                    }
                  }
                }
              }
              heightRanges {
                nodes {
                  termOrder
                  name
                }
              }
              heightWithFenceRanges {
                nodes {
                  termOrder
                  name
                }
              }
              widthRanges {
                nodes {
                  termOrder
                  name
                }
              }
              depthRanges {
                nodes {
                  termOrder
                  name
                }
              }
              weightRanges {
                nodes {
                  termOrder
                  name
                }
              }
              filledWeightRanges {
                nodes {
                  termOrder
                  name
                }
              }
              applications {
                nodes {
                  termOrder
                  name
                }
              }
              productCategories {
                nodes {
                  id
                  name
                }
              }
              featuredImage {
                node {
                  mediaItemUrl
                }
              }
              rolloverImage {
                rolloverImage {
                  mediaItemUrl
                }
              }
              productData {
                productTitleSimple
                pageType
                location
                productGallery {
                  mediaItemUrl
                }
                specification {
                  depth
                  height
                  heightWithFence
                  weight
                  width
                  filledWeight
                  crashtested
                  windtunneltested
                }
                productMeta {
                  stackStatus
                  hirePrice {
                    price
                    info
                    priceOnApplication
                  }
                  buyPrice {
                    price
                    info
                    priceOnApplication
                  }
                }
              }
            }
          }
        }
        ... on WpProductCategory_Productcategorydata_Components_Filters {
          fieldGroupName
        }
        ... on WpProductCategory_Productcategorydata_Components_Products {
          fieldGroupName
          background
        }
        ... on WpProductCategory_Productcategorydata_Components_Table {
          fieldGroupName
          title
          specifications
          products {
            ... on WpProduct {
              title
              featuredImage {
                node {
                  altText
                  mediaItemUrl
                }
              }
              productData {
                productId
                productGallery {
                  altText
                  mediaItemUrl
                }
                specification {
                  depth
                  height
                  heightWithFence
                  weight
                  width
                  filledWeight
                  crashtested
                  windtunneltested
                }
              }
            }
          }
          showProductFeaturedImageAndTitle
        }
        ... on WpProductCategory_Productcategorydata_Components_RelatedProducts {
          background
          fieldGroupName
          products {
            relatedProduct {
                ... on WpProduct {
                id
                featuredImage {
                  node {
                    mediaItemUrl
                  }
                }
                title
                uri
                productCategories {
                  nodes {
                    id
                    name
                  }
                }
                rolloverImage {
                  rolloverImage {
                    mediaItemUrl
                  }
                }
                productData {
                  specification {
                    depth
                    height
                    heightWithFence
                    weight
                    width
                    filledWeight
                    crashtested
                    windtunneltested
                  }
                  productGallery {
                    mediaItemUrl
                  }
                  productMeta {
                    stackStatus
                    hirePrice {
                      price
                      info
                      priceOnApplication
                    }
                    buyPrice {
                      price
                      info
                      priceOnApplication
                    }
                  }
                }
              }
            }
          }
        }
        ... on WpProductCategory_Productcategorydata_Components_RelatedCaseStudies {
          background
          fieldGroupName
          caseStudies {
            featuredCaseStudy {
              ... on WpCaseStudy {
                id
                uri
                title
                featuredImage {
                  node {
                    mediaItemUrl
                  }
                }
              }
            }
          }
        }
        ... on WpProductCategory_Productcategorydata_Components_RelatedArticles {
          background
          fieldGroupName
          articles {
            article {
              ... on WpKnowledgeBaseArticle {
                id
                uri
                title
                featuredImage {
                  node {
                    mediaItemUrl
                  }
                }
              }
            }
          }
        }
        ... on WpProductCategory_Productcategorydata_Components_Media {
          background
          mobileColumns
          columns
          fieldGroupName
          textAlign
          justifyContent
          zoom
          media {
            button {
              target
              title
              url
            }
            content
            title
            titleLink {
              url
              title
              target
            }
            mediaType
            video {
              publicUrl
            }
            videoPoster {
              mediaItemUrl
            }
            image {
              mediaItemUrl
              altText
            }
            imageLink {
              url
              title
              target
            }
            carouselImages {
              ...on WpMediaItem {
                mediaItemUrl
                altText
              }
            }
            autoScroll
            delay
          }
        }
        ... on WpProductCategory_Productcategorydata_Components_LocationList {
          fieldGroupName
        }
        ... on WpProductCategory_Productcategorydata_Components_ContentAndImage {
          mediaType
          background
          content
          button {
            target
            title
            url
          }
          fieldGroupName
          placement
          titleGroup {
            element
            text
          }
          titleLink {
            url
            title
            target
          }
          image {
            mediaItemUrl
            altText
          }
          imageLink {
            url
            title
            target
          }
          video {
            publicUrl
          }
          videoPoster {
            mediaItemUrl
          }
          oembed
          list {
            content
            icon {
              mediaItemUrl
              altText
            }
          }
          carouselImages {
            ...on WpMediaItem {
              mediaItemUrl
              altText
            }
          }
          autoScroll
          delay
        }
        ... on WpProductCategory_Productcategorydata_Components_VideoComponent {
          aspectHeight
          aspectWidth
          fullWidth
          videoEmbed
          fieldGroupName
          background
          title
        }
        ... on WpProductCategory_Productcategorydata_Components_Faqs {
          background
          fieldGroupName
          fullWidth
          faqs {
            faqQuestion
            answer {
              addVideo
              faqAnswer
              faqVideo
            }
          }
        }
        ... on WpProductCategory_Productcategorydata_Components_Content {
          align
          background
          fieldGroupName
          content
          images {
            label
            image {
              mediaItemUrl
              altText
            }
          }
          titleGroup {
            element
            text
          }
        }
        ... on WpProductCategory_Productcategorydata_Components_QuoteFormAndSafesitePromise {
          fieldGroupName
        }
        ... on WpProductCategory_Productcategorydata_Components_Trustpilot {
          background
          fieldGroupName
        }
        ... on WpProductCategory_Productcategorydata_Components_Carousel {
          fieldGroupName
          fullWidth
          images {
            image {
              mediaItemUrl
              altText
            }
          }
          autoScroll
          delay
        } 
        ... on WpProductCategory_Productcategorydata_Components_Hero {
          fieldGroupName
          background
          mobileBackground
          content
          button {
            target
            title
            url
          }
          darkText
          fullHeight
          overlayColour
          overlayOpacity
          uppercaseTitle
          videoFile {
            publicUrl
          }
          videoPoster {
            mediaItemUrl
          }
          titleGroup {
            element
            text
          }
          mobileImage {
            mediaItemUrl
          }
          desktopImage {
            mediaItemUrl
          }
          textShadow {
            x
            y
            blur
            opacity
          }
          carouselImages {
            ...on WpMediaItem {
              mediaItemUrl
              altText
            }
          }
          autoScroll
          delay
        }
        ... on WpProductCategory_Productcategorydata_Components_Spacer {
          fieldGroupName
          background
        }
        ... on WpProductCategory_Productcategorydata_Components_SubscribeToNewsletter {
          fieldGroupName
          background
          title
          subText
          disclaimer
          confirmation
          icon {
            mediaItemUrl
          }
          image {
            mediaItemUrl
          }
        }
        ... on WpProductCategory_Productcategorydata_Components_Accordion {
          background
          fieldGroupName
          accessories {
            ... on WpProduct {
              id
              featuredImage {
                node {
                  mediaItemUrl
                }
              }
              menuOrder
              productData {
                productGallery {
                  mediaItemUrl
                }
              }
              uri
              title
            }
          }
          freeText {
            content
            title
          }
          fullWidth
        }
        ... on WpProductCategory_Productcategorydata_Components_Accreditations {
          fieldGroupName
          global
          images {
            image {
              altText
              mediaItemUrl
            }
            link {
              url
              target
              title
            }
          }
          autoScroll
          delay
        }
      }
    }
    products {
      nodes {
        ... on WpProduct {
          title
          uri
          id
          menuOrder
          wpChildren {
            nodes {
              ... on WpProduct {
                productData {
                  productMeta {
                    stackStatus
                    hirePrice {
                      price
                      info
                      priceOnApplication
                    }
                    buyPrice {
                      price
                      info
                      priceOnApplication
                    }
                  }
                }
              }
            }
          }
          heightRanges {
            nodes {
              termOrder
              name
            }
          }
          heightWithFenceRanges {
            nodes {
              termOrder
              name
            }
          }
          widthRanges {
            nodes {
              termOrder
              name
            }
          }
          depthRanges {
            nodes {
              termOrder
              name
            }
          }
          weightRanges {
            nodes {
              termOrder
              name
            }
          }
          filledWeightRanges {
            nodes {
              termOrder
              name
            }
          }
          applications {
            nodes {
              termOrder
              name
            }
          }
          productCategories {
            nodes {
              id
              name
            }
          }
          featuredImage {
            node {
              mediaItemUrl
            }
          }
          rolloverImage {
            rolloverImage {
              mediaItemUrl
            }
          }
          productData {
            productTitleSimple
            pageType
            location
            productGallery {
              mediaItemUrl
            }
            specification {
              depth
              height
              heightWithFence
              weight
              width
              filledWeight
              crashtested
              windtunneltested
            }
            productMeta {
              stackStatus
              hirePrice {
                price
                info
                priceOnApplication
              }
              buyPrice {
                price
                info
                priceOnApplication
              }
            }
          }
        }
      }
    }
    seo {
      title
      metaDesc
      focuskw
      metaKeywords
      metaRobotsNoindex
      metaRobotsNofollow
      opengraphTitle
      opengraphDescription
      opengraphImage {
        sourceUrl
      }
      twitterTitle
      twitterDescription
      twitterImage {
        sourceUrl
      }
      canonical
      cornerstone
      schema {
        raw
      }
    }
  }
}`;
